module.exports = __webpack_public_path__ + "static/media/03-2-galeria-03-coach@2x.4a27655d.jpg";